import { render, staticRenderFns } from "./BraceletBuilder.vue?vue&type=template&id=25f8e83e&scoped=true&"
import script from "./BraceletBuilder.vue?vue&type=script&lang=js&"
export * from "./BraceletBuilder.vue?vue&type=script&lang=js&"
import style0 from "./BraceletBuilder.vue?vue&type=style&index=0&id=25f8e83e&prod&lang=scss&scoped=true&"
import style1 from "./BraceletBuilder.vue?vue&type=style&index=1&id=25f8e83e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8e83e",
  null
  
)

export default component.exports